/* December Again — scroll reveal, parallax and the sticky buy bar.
   Ported from the approved design's own script. Kept dependency-free and
   guarded so a second copy on the page cannot double-bind. */
(function () {
  if (window.__daMotion) return;
  window.__daMotion = true;

  function show(el) { el.dataset.shown = '1'; }

  function arm() {
    var reveals = document.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { show(en.target); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -6% 0px' });
      reveals.forEach(function (el) {
        if (el.dataset.observed) return;
        el.dataset.observed = '1';
        // armed only once JS is running, so no-JS visitors see the content
        el.dataset.armed = '1';
        io.observe(el);
      });
    } else {
      reveals.forEach(show);
    }
  }

  function onScroll() {
    var vh = window.innerHeight;
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      if (!el.dataset.shown && el.getBoundingClientRect().top < vh * 0.94) show(el);
    });
    document.querySelectorAll('[data-parallax]').forEach(function (p) {
      var fq = parseFloat(p.getAttribute('data-parallax')) || 0;
      var r = p.getBoundingClientRect();
      p.style.transform =
        'translate3d(0,' + ((r.top + r.height / 2 - vh / 2) * -fq).toFixed(1) + 'px,0)';
    });
    var bar = document.querySelector('[data-sticky-bar]');
    var a = document.querySelector('[data-buy-anchor]');
    if (bar && a) {
      bar.style.transform =
        a.getBoundingClientRect().bottom < 0 ? 'translateY(0)' : 'translateY(120%)';
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  document.addEventListener('DOMContentLoaded', function () { arm(); onScroll(); });
  setTimeout(function () { arm(); onScroll(); }, 60);
})();

/* --- product page: gallery, variants, quantity ------------------------ */
(function () {
  if (window.__daProduct) return;
  window.__daProduct = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // quantity steppers, wherever they appear
    document.querySelectorAll('[data-da-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentNode.querySelector('input[name="quantity"]');
        if (!input) return;
        var next = (parseInt(input.value, 10) || 1) + parseInt(b.dataset.daQty, 10);
        input.value = next < 1 ? 1 : next;
      });
    });

    // gallery: thumbnails on desktop, swipe + dots on mobile
    var slides = document.querySelector('[data-da-slides]');
    if (slides) {
      var all = [].slice.call(slides.querySelectorAll('[data-da-slide]'));
      var thumbs = [].slice.call(document.querySelectorAll('[data-da-thumb]'));
      var dots = [].slice.call(document.querySelectorAll('[data-da-dot]'));

      function select(i) {
        all.forEach(function (s, n) { s.classList.toggle('is-on', n === i); });
        thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === i); });
        dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
        // on mobile the slides are a scroll rail, so move it too
        if (window.matchMedia('(max-width: 899px)').matches && all[i]) {
          slides.scrollTo({ left: all[i].offsetLeft - slides.offsetLeft, behavior: 'smooth' });
        }
      }
      select(0);
      thumbs.forEach(function (t) { t.addEventListener('click', function () { select(+t.dataset.daThumb); }); });
      dots.forEach(function (d) { d.addEventListener('click', function () { select(+d.dataset.daDot); }); });

      // keep the dots honest while the reader swipes
      var tick;
      slides.addEventListener('scroll', function () {
        clearTimeout(tick);
        tick = setTimeout(function () {
          var i = Math.round(slides.scrollLeft / (slides.clientWidth || 1));
          dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
          thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === i); });
        }, 90);
      }, { passive: true });
    }

    // variant options -> the hidden input Shopify (and apps) read
    var field = document.querySelector('[data-da-variant-input]');
    var mapEl = document.querySelector('[data-da-variant-map]');
    if (field && mapEl) {
      var variants = [];
      try { variants = JSON.parse(mapEl.textContent); } catch (e) { variants = []; }
      var opts = [].slice.call(document.querySelectorAll('[data-da-opt]'));
      opts.forEach(function (input) {
        input.addEventListener('change', function () {
          var chosen = [];
          opts.forEach(function (o) { if (o.checked) chosen[+o.dataset.daOpt] = o.value; });
          var want = chosen.join(' / ');
          var hit = variants.filter(function (x) { return x.title === want; })[0];
          if (hit) {
            field.value = hit.id;
            // apps and Horizon both listen for a change on the field
            field.dispatchEvent(new Event('change', { bubbles: true }));
          }
          document.querySelectorAll('.da-pd__swatch').forEach(function (l) {
            l.classList.toggle('is-on', !!l.querySelector('input:checked'));
          });
        });
      });
    }
  });
})();

/* --- Christmas songs in the customiser's suggestion list ---------------
   The picker's "Popular Searches" panel is filled from Soufeel's Spotify
   chart, not from MadeMine's catalogue:

     GET https://ai.soufeel.com/spotifyrank/SpotifyrankList?number=10

   It is the same chart for every merchant using the app, so a Christmas
   store opened its song picker on Ed Sheeran, Luke Combs and Bruno Mars.
   The endpoint takes no keyword — number is the only parameter it honours —
   so the rows are replaced on the way back instead.

   Every track below was checked against Spotify's public oEmbed endpoint
   before being written here: the id resolves, the title is what we say it
   is, and the artwork url is the one Spotify itself returns. Four other
   candidates were dropped because their ids did not resolve. Nothing here
   is from memory.

   Any failure passes the original response through untouched, so the worst
   case is the chart they get today.
   -------------------------------------------------------------------- */
(function () {
  if (window.__daSongs) return;
  window.__daSongs = true;

  var RANK = /ai\.soufeel\.com\/spotifyrank/i;

  /* The rows are written in the chart's exact shape — album, albumThumbnail,
     name, artists, preview_url, duration_ms, uri, update_at, num, id. The
     first attempt carried only the four fields that are visible on screen,
     which drew the list correctly and then would not select: the picker
     identifies a track by its `uri`, and there wasn't one.

     The artwork hashes are the ones Spotify's oEmbed returned for each
     verified id; ab67616d0000b273 and ab67616d00004851 are Spotify's own
     large and thumbnail size prefixes. preview_url is "None", the same
     value the live chart uses for a track without a preview — the 30s
     preview needs an authenticated Spotify call we do not have, so the row
     plays nothing and selects fine, which is the right way round. */
  var SONGS = [
    {
        "album": "https://i.scdn.co/image/ab67616d0000b273c0862332847213b151ffab31",
        "albumThumbnail": "https://i.scdn.co/image/ab67616d00004851c0862332847213b151ffab31",
        "name": "All I Want for Christmas Is You",
        "artists": "Mariah Carey",
        "preview_url": "None",
        "duration_ms": 0,
        "uri": "spotify:track:0bYg9bo50gSsH3LtXe2SQn",
        "update_at": "2026-01-01 00:00:00",
        "num": 10000,
        "id": 90000
    },
    {
        "album": "https://i.scdn.co/image/ab67616d0000b273f2d2adaa21ad616df6241e7d",
        "albumThumbnail": "https://i.scdn.co/image/ab67616d00004851f2d2adaa21ad616df6241e7d",
        "name": "Last Christmas",
        "artists": "Wham!",
        "preview_url": "None",
        "duration_ms": 0,
        "uri": "spotify:track:2FRnf9qhLbvw8fu4IBXx78",
        "update_at": "2026-01-01 00:00:00",
        "num": 10001,
        "id": 90001
    },
    {
        "album": "https://i.scdn.co/image/ab67616d0000b273bc5b8079eaec602335cc6e5d",
        "albumThumbnail": "https://i.scdn.co/image/ab67616d00004851bc5b8079eaec602335cc6e5d",
        "name": "It's the Most Wonderful Time of the Year",
        "artists": "Andy Williams",
        "preview_url": "None",
        "duration_ms": 0,
        "uri": "spotify:track:5hslUAKq9I9CG2bAulFkHN",
        "update_at": "2026-01-01 00:00:00",
        "num": 10002,
        "id": 90002
    },
    {
        "album": "https://i.scdn.co/image/ab67616d0000b2736d88028a85c771f37374c8ea",
        "albumThumbnail": "https://i.scdn.co/image/ab67616d000048516d88028a85c771f37374c8ea",
        "name": "Let It Snow! Let It Snow! Let It Snow!",
        "artists": "Dean Martin",
        "preview_url": "None",
        "duration_ms": 0,
        "uri": "spotify:track:2uFaJJtFpPDc5Pa95XzTvg",
        "update_at": "2026-01-01 00:00:00",
        "num": 10003,
        "id": 90003
    },
    {
        "album": "https://i.scdn.co/image/ab67616d0000b27395517befb15ad5d63af701ab",
        "albumThumbnail": "https://i.scdn.co/image/ab67616d0000485195517befb15ad5d63af701ab",
        "name": "It's Beginning to Look a Lot like Christmas",
        "artists": "Michael Bublé",
        "preview_url": "None",
        "duration_ms": 0,
        "uri": "spotify:track:0lLdorYw7lVrJydTINhWdI",
        "update_at": "2026-01-01 00:00:00",
        "num": 10004,
        "id": 90004
    },
    {
        "album": "https://i.scdn.co/image/ab67616d0000b273fd56f3c7a294f5cfe51c7b17",
        "albumThumbnail": "https://i.scdn.co/image/ab67616d00004851fd56f3c7a294f5cfe51c7b17",
        "name": "Jingle Bell Rock",
        "artists": "Bobby Helms",
        "preview_url": "None",
        "duration_ms": 0,
        "uri": "spotify:track:7vQbuQcyTflfCIOu3Uzzya",
        "update_at": "2026-01-01 00:00:00",
        "num": 10005,
        "id": 90005
    }
];

  var original = window.fetch;
  window.fetch = function (input) {
    var url = '';
    try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
    if (!RANK.test(url)) return original.apply(this, arguments);

    var args = arguments, self = this;
    // the app's own envelope is kept; only the rows are swapped
    return original.apply(self, args).then(function (res) {
      return res.json().then(function (body) {
        // SONGS are already written in the chart's own shape, so they go
        // straight in — no mapper to drift out of sync with it.
        body.data = SONGS;
        return new Response(JSON.stringify(body), {
          status: 200, headers: { 'Content-Type': 'application/json' }
        });
      });
    }).catch(function () { return original.apply(self, args); });
  };
})();

/* --- cart page --------------------------------------------------------
   Quantity, removal and the totals all go through Shopify's own cart
   endpoints. The controls are real form elements underneath, so with
   JavaScript off the page still works — this only spares the reload.
   -------------------------------------------------------------------- */
(function () {
  if (window.__daCart) return;
  window.__daCart = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US',
        { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  ready(function () {
    var root = document.querySelector('.da-cart');
    if (!root) return;

    var busy = false;

    function paint(cart) {
      var sub = document.querySelector('[data-da-subtotal]');
      var tot = document.querySelector('[data-da-total]');
      var mir = document.querySelector('[data-da-total-mirror]');
      if (sub) sub.textContent = money(cart.items_subtotal_price, cart.currency);
      if (tot) tot.textContent = money(cart.total_price, cart.currency) + ' ' + (cart.currency || '');
      if (mir) mir.textContent = money(cart.total_price, cart.currency);

      // the header badge, wherever the theme put it
      document.querySelectorAll('.da-head__count, .cart-bubble__text, [data-cart-count]')
        .forEach(function (el) { el.textContent = cart.item_count; });

      if (cart.item_count === 0) window.location.reload();
    }

    function change(line, quantity, row) {
      if (busy) return;
      busy = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (quantity === 0 && row) {
            row.setAttribute('data-da-going', '');
            setTimeout(function () { row.remove(); }, 300);
          }
          paint(cart);
        })
        .catch(function () { window.location.reload(); })
        .then(function () { busy = false; });
    }

    root.addEventListener('click', function (e) {
      var step = e.target.closest('[data-da-step]');
      if (step) {
        var row = step.closest('[data-da-line]');
        var input = row.querySelector('[data-da-qty]');
        var next = (parseInt(input.value, 10) || 1) + parseInt(step.dataset.daStep, 10);
        if (next < 0) next = 0;
        input.value = next;
        change(parseInt(row.dataset.daLine, 10), next, row);
        return;
      }

      var remove = e.target.closest('[data-da-remove]');
      if (remove) {
        e.preventDefault();
        var r = remove.closest('[data-da-line]');
        change(parseInt(r.dataset.daLine, 10), 0, r);
      }
    });

    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-da-qty]');
      if (!input) return;
      var row = input.closest('[data-da-line]');
      var q = parseInt(input.value, 10);
      if (isNaN(q) || q < 0) q = 1;
      input.value = q;
      change(parseInt(row.dataset.daLine, 10), q, row);
    });

    /* the bar appears once the real checkout button has scrolled away */
    var bar = document.querySelector('[data-da-cart-bar]');
    var summary = document.querySelector('[data-da-summary]');
    if (bar && summary && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        if (en.isIntersecting) bar.removeAttribute('data-da-shown');
        else bar.setAttribute('data-da-shown', '');
      }, { threshold: 0.15 }).observe(summary);
    }

    /* recommendations, from Shopify's own endpoint */
    var recs = document.querySelector('[data-da-recs]');
    if (recs) {
      fetch(recs.dataset.url.replace(/&section_id=[^&]*/, '') + '&limit=3')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var list = recs.querySelector('[data-da-recs-list]');
          var items = (data && data.products) || [];
          if (!items.length) { recs.remove(); return; }
          items.forEach(function (p) {
            var el = document.createElement('div');
            el.className = 'da-cart__rec';
            el.innerHTML =
              (p.featured_image ? '<img src="' + p.featured_image + '&width=600" alt="" loading="lazy">' : '') +
              '<div class="da-cart__rec-body">' +
                '<a class="da-cart__rec-name" href="' + p.url + '">' + p.title + '</a>' +
                '<div class="da-cart__rec-price">' + money(p.price, data.currency) + '</div>' +
                '<button type="button" class="da-cart__rec-add" data-da-add="' +
                  (p.variants && p.variants[0] ? p.variants[0].id : '') + '">ADD TO CART</button>' +
              '</div>';
            list.appendChild(el);
          });
        })
        .catch(function () { recs.remove(); });

      recs.addEventListener('click', function (e) {
        var add = e.target.closest('[data-da-add]');
        if (!add || !add.dataset.daAdd) return;
        add.disabled = true;
        add.textContent = 'ADDING…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(add.dataset.daAdd), quantity: 1 }] })
        })
          .then(function () { window.location.reload(); })
          .catch(function () { add.disabled = false; add.textContent = 'ADD TO CART'; });
      });
    }
  });
})();
